import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getAdminSetPasswordPath = () => {
  return urlHelper('/auth/admin/set-password/');
};
